import {type PropsWithChildren, useState} from 'react';
import {ResponsiveHeader} from '@prtimes-public-components/header/responsive-header';
import {ResponsiveFooter} from '@prtimes-public-components/footer/responsive-footer';
import {LoginModal} from '@prtimes-public-components/login-modal';
import {usePopularKeywordsQuery} from './use-popular-keywords-query';
import {useCurrentUserQuery} from './use-current-user-query';
import {useViewStyle, ViewStyleProvider} from '@/hooks/use-view-style';

type Props = PropsWithChildren;

export function PublicResponsiveLayout({children}: Props) {
  return (
    <ViewStyleProvider>
      <PublicResponsiveLayoutInternal>
        {children}
      </PublicResponsiveLayoutInternal>
    </ViewStyleProvider>
  );
}

function PublicResponsiveLayoutInternal({children}: Props) {
  const [isLoginModalShown, setIsLoginModalShown] = useState(false);
  const showLoginModal = () => {
    setIsLoginModalShown(true);
  };

  const closeLoginModal = () => {
    setIsLoginModalShown(false);
  };

  const userQuery = useCurrentUserQuery();
  const myPagePath = (() => {
    if (userQuery.data === undefined) {
      return {isLoading: true as const};
    }

    return {
      isLoading: false as const,
      value: userQuery.data.user?.myPagePath,
    };
  })();
  const {viewStyle, setViewStyle} = useViewStyle();
  const {data: popularKeywordsQuery} = usePopularKeywordsQuery();

  return (
    <div>
      <ResponsiveHeader
        myPagePath={myPagePath}
        showLoginModal={showLoginModal}
        viewStyle={viewStyle}
        setViewStyle={setViewStyle}
        popularKeywords={popularKeywordsQuery}
      />

      <main>{children}</main>

      <ResponsiveFooter
        myPagePath={myPagePath}
        showLoginModal={showLoginModal}
      />

      <LoginModal isOpen={isLoginModalShown} closeModal={closeLoginModal} />
    </div>
  );
}
